export const EventLogAllTR={
ELogID:{en:'ELogID',cs:'ELogID',dataType:'number',format:'#0',required:true},
ELogObjectID:{en:'Object Table',cs:'',dataType:'number',format:'#0',required:true},
ELogObjectPK:{en:'Object Primary Key',cs:'',dataType:'number',format:'#0',required:true},
ELogTableName:{en:'ELogTableName',cs:'ELogTableName',dataType:'string',required:true,maxLength:50},
ELogTablePK:{en:'ELogTablePK',cs:'ELogTablePK',dataType:'number',format:'#0',required:true},
ELogSeq:{en:'ELogSeq',cs:'ELogSeq',dataType:'number',format:'#0',required:true},
ELogUserID:{en:'User',cs:'',dataType:'number',format:'#0',required:true},
ELogDateTime:{en:'Event Date/Time',cs:'',dataType:'datetime',format:'dd.MM.yyyy HH:mm:ss',required:true},
ELogEventDesc:{en:'Event Type',cs:'',dataType:'string',required:true,maxLength:255},
ELogEventText:{en:'Event Description',cs:'',dataType:'string'},
UserFullName:{en:'Full Name',cs:'',dataType:'string',maxLength:50}
}